import React, { useContext, useRef } from 'react';
import Products from './components/Products';
import { ProductsContext, CheckoutsContext, CartContext } from "./components/products/productsContext"
import Client from 'shopify-buy';

const getParamsValue = (attribute) => {
  const urlSearch = window.location.search.replace("?", "");
  if (urlSearch.indexOf(attribute) === -1) {
    return null;
  }
  const splitArray = urlSearch.split(`${attribute}=`)

  let value = null;
  if (splitArray[1]) {
    value = splitArray[1].split('&')[0];
  }
  return value;
}

const ProductList = () => {
  
  let products = useContext(ProductsContext)
  const [checkout, _setCheckout] = useContext(CheckoutsContext)
  const [showCart, setShowCart] = useContext(CartContext)

  const container2 = useRef( null );

  const client = Client.buildClient({
    domain: 'blue-lion-apparel-llc.myshopify.com',
    storefrontAccessToken: '34acd07c5cbc899e721d17d94b11b2c6'
  });

  return (
    <div className="App">
      <button ref={container2} className="cart-button mobile-view" style={(checkout.lineItems.length > 0 && !showCart) ? {} : { display: "none" }}
        onClick={() => setShowCart(true)}>
        <div style={{ fontSize: "27px", color: "white" }}>{checkout.lineItems.length}</div>
        <img style={{ height: "39px", marginLeft: "12px" }} src={require("./components/images/cart.png")} alt="Icon not avilable"></img>
      </button>
      {getParamsValue('id') ?
        <Products
          client={client}
          customCollection={products.customCollection}
          customCollectionData={products.customCollectionData}
        />
        :
        <Products
          shirts={products.shirts}
          hats={products.hats}
          accessarries={products.accessarries}
          client={client}
          collection1={products.collection1}
          collection2={products.collection2}
          collection3={products.collection3}
        />
      }
    </div>
  );
}
export default ProductList;



// WEBPACK FOOTER //
// ./src/ProductList.js